export const seafoodProgramSource = [
    {
        title: 'San Sebastian Tapas',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FPxgSb_large.jpg?alt=media&token=65ddb077-5fa0-49c6-b4f2-5ec291eea9aa',
        description:
            'San Sebastian hiver seg med på feiringen\n\nSjømat vil være i fokus på menyen denne uken, blant annet med blåskjell fra Åfjord og kveite fra Averøy.\n\nKom innom oss for deilige spanske smaker med norske råvarer\n\nVelg blant over 35 av våre tapas-retter',
        place: 'Midtbyen/ Trondheim torg',
        address: 'Kongens gate 9, 7013 Trondheim, Norge',
        time: '11:00 - 21:00',
        date: '17.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/san-sebastian-tapas/'
    },
    {
        title: 'SOT Sabrura Torvet!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FwTzRg_large.jpg?alt=media&token=5bf84749-2b36-4c64-8808-d6ccaa6ccba2',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på SOT Sabrura Torvet har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: '',
        address: '',
        time: '13:00 - 22:00',
        date: '17.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sot-sabrura-torvet/'
    },
    {
        title: 'Sabrura Solsiden!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2Frytvk_large.jpg?alt=media&token=cfc8b521-00c1-4ab1-b6c7-3ab8edc7de7c',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura Solsiden har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: '',
        address: '',
        time: '13:00 - 22:00',
        date: '17.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-solsiden/'
    },
    {
        title: 'Sabrura Bakklandet!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FNt0um_large.jpg?alt=media&token=38e496a4-90cc-41c8-aacd-3e4925862832',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura Bakklandet har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: '',
        address: '',
        time: '13:00 - 23:00',
        date: '17.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-bakklandet/'
    },
    {
        title: 'Bakgården Tapas!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F34Moe_large.jpg?alt=media&token=6302aeb0-2930-4240-85a1-121be58bf8e3',
        description:
            'På Bakgården Tapas bar og spiseri er vi med på feiringen!&nbsp;\n\nSjømat vil være i fokus på menyen denne uken. Vi tilbyr både stor og liten sjømatsmeny til gode priser, hvor fokuset ligger på Norske råvarer . &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
        place: 'Bakgården Bar og Spiseri',
        address: 'Kjøpmannsgata 40, 7011 Trondheim, Norge',
        time: '15:00 - 22:00',
        date: '17.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/bakgarden-tapas/'
    },
    {
        title: 'Brasserie Britannia',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FwwmNV_large.jpg?alt=media&token=85529179-16f6-4e22-abfe-f3db7e7ebe56',
        description:
            'I forbindelse med Norway Seafood Festival vil Brasserie Britannia servere en 3-retters meny basert på flotte lokale råvarer fra havet fra 15.03 tom. 21.03.',
        place: 'Britannia Hotel',
        address: 'Dronningens gate 5, 7011 Trondheim, Norge',
        time: '16:00 - 22:00',
        date: '17.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/brasserie-britannia/'
    },
    {
        title: 'To Rom og Kjøkken',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F20XxY_large.jpg?alt=media&token=7d2d7ea5-aff7-400b-a0f2-18c78f9679ad',
        description:
            '15.-21. mars i år arrangeres Norway Seafood Festival i Trondheim.\n\nPå To Rom og Kjøkken er vi med på feiringen, og sjømat vil være i fokus på menyen denne uken.\n\nVi serverer våre Smaksmenyer på 3-, 5- og 7-retters menyer, hvor lokal sjømat og det beste fra havet spiller hovedrollen.',
        place: 'To Rom og Kjøkken',
        address: 'Carl Johans gate 5 Trondheim   7010 Norway',
        time: '16:00 - 22:00',
        date: '17.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/to-rom-og-kjokken/'
    },
    {
        title: 'Grafen Trondheim',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2Fqahfy_large.jpg?alt=media&token=8ba84fee-5731-4371-b10a-5870ef7b8184',
        description:
            '15-21 mar arrangeres Norwegian Seafood Festival, og Grafen ønsker selvsagt og være med på feiringen. I perioden vil vi tilby en egen meny med fokos på råvarene som også har fokus i Bocuse d`or Trondheim 2024.\n\nMenyen vil ha fokus på havets delikatesser som skrei, kamskjell og klippfisk.\n\nVår a la carte vil også i perioden bære preg av byens arrangement.\n\nBord kan bookes online på www.grafentrondheim.no/booking',
        place: 'Grafen Trondheim',
        address: 'Kongens gate 8, 7011 Trondheim, Norge',
        time: '16:00 - 22:00',
        date: '17.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/grafen-trondheim/'
    },
    {
        title: 'Sjømatens fremtid',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FS2BaJ_large.jpg?alt=media&token=d81d12f8-6bf3-4a6c-ab2f-bbb45de44bd0',
        description:
            'Norge har verdens beste sjømat og er i toppen internasjonalt i sjømatkonsum. Samtidig spiser vi mindre og mindre sjømat hvert år, og spesielt hos barn og unge går forbruket betydelig ned. På Sjømat 2024 stiller vi de vanskelige spørsmålene om årsakene til utviklingen samt hvilke grep som kan snu trenden. Du får den siste forbrukerinnsikten og vi skal snakke om verdikjeder, omdømme, bærekraft og andre høyst relevante tema.\n\nSjømat 2024 – Sjømatens fremtid er et samarbeid mellom Norway Seafood Festival, NTNU Food Forum og Næringsforeningen i Trondheimsregionen.\n\n<strong>Påmeldingsfrist</strong><br>15.03.2024 12.00\n\n<strong>Se program her:&nbsp;</strong>\n\n<a href="https://www.nitr.no/no/Moter/c76400be-dbb0-ce3a-f71c-65d5c0e34abf">Sjømat 2024 – Sjømatens fremtid | Næringsforeningen i Trondheimsregionen</a>',
        place: 'Clarion Hotel Trondheim',
        address: 'Brattørkaia 1 Trondheim 7010',
        time: '10:00 - 16:00',
        date: '18.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sjomatens-fremtid/'
    },
    {
        title: 'Sabrura City Syd',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F8RyhI_large.jpg?alt=media&token=e9582e0b-7355-446a-9a6c-4db0ed776ae1',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura City Syd har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: 'City Syd',
        address: 'Østre Rosten 28-30, 7075 Tiller, Norge',
        time: '10:15 - 20:00',
        date: '18.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-city-syd/'
    },
    {
        title: 'San Sebastian Tapas',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FPxgSb_large.jpg?alt=media&token=65ddb077-5fa0-49c6-b4f2-5ec291eea9aa',
        description:
            'San Sebastian hiver seg med på feiringen\n\nSjømat vil være i fokus på menyen denne uken, blant annet med blåskjell fra Åfjord og kveite fra Averøy.\n\nKom innom oss for deilige spanske smaker med norske råvarer\n\nVelg blant over 35 av våre tapas-retter',
        place: 'Midtbyen/ Trondheim torg',
        address: 'Kongens gate 9, 7013 Trondheim, Norge',
        time: '11:00 - 21:00',
        date: '18.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/san-sebastian-tapas-2/'
    },
    {
        title: 'Krambua 15/3 – 21/3 2024',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F6gHIG_large.jpg?alt=media&token=d4bb2e27-69b3-4fb0-ae38-9e148366f0f7',
        description:
            'På Krambua, i Krambugata, er du hjertelig velkommen enten det er hverdag eller fest. Hos oss møter du hyggelige folk og kan spise god mat i stemningsfulle lokaler. Er du ute etter en god lunsj, middag eller bare noe godt å drikke i baren så vil du uansett finne deg godt til rette i de uformelle og koselige lokalene våre i Trondheim. Ønsker du å booke ditt eget rom kan vil tilby dette til deg og din gruppe. Bestill gjerne bord så er du sikker på å få plass!\n\nPå Krambua kan vi friste med mye godt på menyen og hjemmelaget Bacalao til redusert pris under hele festivalperioden 15/03 – 21/03 Tilbudspris kr. 299,-\n\nHusk å reservere bord i god tid.\n\n<a href="https://www.krambuatrondheim.no/reservations">Bestill bord — Krambua (krambuatrondheim.no)</a>\n\n<a href="mailto:post@krambua.no">post@krambua.no</a>\n\nTlf: 73535253',
        place: 'Krambua',
        address: 'Krambugata 12-14 Trondheim 7010',
        time: '11:00',
        date: '18.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/krambua-15-3-21-3-2024/'
    },
    {
        title: 'Sabrura Sirkus!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FQ17dd_large.jpg?alt=media&token=106b9884-51e5-4a55-b0b3-3ac23393c463',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura Sirkus har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: 'Sirkus Shopping',
        address: 'Falkenborgvegen 1, 7044 Trondheim, Norge',
        time: '11:00 - 21:00',
        date: '18.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-sirkus/'
    },
    {
        title: 'Sabrura City Lade',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FxlOAY_large.jpg?alt=media&token=084fbfb0-34d2-408f-a669-33be0098e3ff',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura City Lade har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: 'City lade',
        address: 'Haakon VIIs gt. 9, 7041 Trondheim, Norge',
        time: '11:00 - 21:00',
        date: '18.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-city-lade/'
    },
    {
        title: 'SOT Sabrura Torvet!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FwTzRg_large.jpg?alt=media&token=5bf84749-2b36-4c64-8808-d6ccaa6ccba2',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på SOT Sabrura Torvet har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: '',
        address: '',
        time: '11:00 - 22:00',
        date: '18.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sot-sabrura-torvet-3/'
    },
    {
        title: 'Sabrura Solsiden!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2Frytvk_large.jpg?alt=media&token=cfc8b521-00c1-4ab1-b6c7-3ab8edc7de7c',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura Solsiden har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: '',
        address: '',
        time: '13:00 - 22:00',
        date: '18.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-solsiden-3/'
    },
    {
        title: 'Sabrura Bakklandet!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FNt0um_large.jpg?alt=media&token=38e496a4-90cc-41c8-aacd-3e4925862832',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura Bakklandet har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: '',
        address: '',
        time: '15:00 - 22:00',
        date: '18.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-bakklandet-3/'
    },
    {
        title: 'Bakgården Tapas!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F34Moe_large.jpg?alt=media&token=6302aeb0-2930-4240-85a1-121be58bf8e3',
        description:
            'På Bakgården Tapas bar og spiseri er vi med på feiringen!&nbsp;\n\nSjømat vil være i fokus på menyen denne uken. Vi tilbyr både stor og liten sjømatsmeny til gode priser, hvor fokuset ligger på Norske råvarer . &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
        place: 'Bakgården Bar og Spiseri',
        address: 'Kjøpmannsgata 40, 7011 Trondheim, Norge',
        time: '15:00 - 22:00',
        date: '18.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/bakgarden-tapas-3/'
    },
    {
        title: 'The Crab og Norway Seafood Festival',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FioshX_large.jpg?alt=media&token=d97c2f0f-71fa-40b4-b784-4ee292f8b04f',
        description:
            '15.-21. mars arrangeres Norway Seafoof Festival i Trondheim og The Crab deltar så klart.\n\nVi har som vanlig fokus på de beste råvarene fra havet i våre menyer og gleder oss til å ta imot alle sjømat-elskere denne uka!\n\nLørdag arrangerer vi skalldyrkurs med Ola kl 12. (Se eget event)\n\nVelkommen til oss!\n\nFor booking <a href="www.thecrab.no">www.thecrab.no</a> eller send en epost til post@thecrab.no',
        place: 'The Crab, Kjøpmannsgata 7',
        address: 'Kjøpmannsgata 7, 7013 Trondheim, Norge',
        time: '16:00 - 22:00',
        date: '18.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/the-crab-og-norway-seafood-festival/'
    },
    {
        title: 'Akt Bar og Smugspiseri',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FLGVxI_large.jpg?alt=media&token=f2380bb4-9397-43d0-8d23-d4424688ecdd',
        description:
            '15.-21. mars i år arrangeres Norway Seafood Festival i Trondheim. &nbsp;\n\nPå Akt Bar og Smugspiseri er vi med på feiringen, og sjømat vil være i fokus på menyen denne uken.\n\nBesøk oss for en deilig 3-retters middag, eller velg fra vår spennende a la carte meny.',
        place: 'Akt Bar og Smugspiseri',
        address: 'Kjøpmannsgata 44, 7010 Trondheim, Norge',
        time: '16:00',
        date: '18.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/akt-bar-og-smugspiseri/'
    },
    {
        title: 'Brasserie Britannia',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FwwmNV_large.jpg?alt=media&token=85529179-16f6-4e22-abfe-f3db7e7ebe56',
        description:
            'I forbindelse med Norway Seafood Festival vil Brasserie Britannia servere en 3-retters meny basert på flotte lokale råvarer fra havet fra 15.03 tom. 21.03.',
        place: 'Britannia Hotel',
        address: 'Dronningens gate 5, 7011 Trondheim, Norge',
        time: '16:00 - 22:00',
        date: '18.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/brasserie-britannia-3/'
    },
    {
        title: 'To Rom og Kjøkken',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F20XxY_large.jpg?alt=media&token=7d2d7ea5-aff7-400b-a0f2-18c78f9679ad',
        description:
            '15.-21. mars i år arrangeres Norway Seafood Festival i Trondheim.\n\nPå To Rom og Kjøkken er vi med på feiringen, og sjømat vil være i fokus på menyen denne uken.\n\nVi serverer våre Smaksmenyer på 3-, 5- og 7-retters menyer, hvor lokal sjømat og det beste fra havet spiller hovedrollen.',
        place: 'To Rom og Kjøkken',
        address: 'Carl Johans gate 5 Trondheim   7010 Norway',
        time: '16:00 - 22:00',
        date: '18.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/to-rom-og-kjokken-3/'
    },
    {
        title: 'Grafen Trondheim',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2Fqahfy_large.jpg?alt=media&token=8ba84fee-5731-4371-b10a-5870ef7b8184',
        description:
            '15-21 mar arrangeres Norwegian Seafood Festival, og Grafen ønsker selvsagt og være med på feiringen. I perioden vil vi tilby en egen meny med fokos på råvarene som også har fokus i Bocuse d`or Trondheim 2024.\n\nMenyen vil ha fokus på havets delikatesser som skrei, kamskjell og klippfisk.\n\nVår a la carte vil også i perioden bære preg av byens arrangement.\n\nBord kan bookes online på www.grafentrondheim.no/booking',
        place: 'Grafen Trondheim',
        address: 'Kongens gate 8, 7011 Trondheim, Norge',
        time: '16:00 - 22:00',
        date: '18.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/grafen-trondheim-3/'
    },
    {
        title: 'Spontan x sjømat festival',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F0JnQh_large.jpg?alt=media&token=94d2e9fd-29a6-4090-891c-b1fc28d10791',
        description:
            '15.-21. mars i år arrangeres Norway Seafood Festival i Trondheim.\n\nVi gleder oss masse til sjømat festivalen og tilbyr i denne perioden en meny på syv serveringer av lokale råvarer og sjømat fra Trøndelag\n\nphoto: Even B Solheim. ebs.photography&nbsp;',
        place: 'Spontan Vinbar',
        address: 'Fjordgata 1, 7010 Trondheim, Norway',
        time: '17:00',
        date: '18.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/spontan-x-sjomat-festival/'
    },
    {
        title: 'Fagn Bistro mandag',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F0jV5Y_large.jpg?alt=media&token=731708a7-9594-4d7b-a6cf-c558cbd6fdf2',
        description:
            '15-21.mars arrangeres Norway Seafood Festival I Trondheim\n\nVi tilbyr denne mandagen en herlig 3 retters meny basert på alt det flotte trøndelag har å tilby av sjømat i annledningen sjømatfestivalen.&nbsp;\n\nMenyen tar utgangspunkt i lokale råvarer med stort fokus på sjømat i alle ledd.&nbsp;<br>&nbsp;',
        place: 'Fagn Bistro',
        address: 'Ørjaveita 4, 7010 Trondheim, Norge',
        time: '17:00 - 22:00',
        date: '18.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/fagn-bistro-mandag/'
    },
    {
        title: 'Visit Bjørn Bacalao Party!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FPka40_large.jpg?alt=media&token=e03900c3-a433-4f25-b223-6073165adb2b',
        description:
            'Billetten inkluderer all mat og underholdning, du velger og kjøper drikke underveis.\n\nDet serveres røkt laks og ørret fra Hitra og Frøya (Garnviks Røkeri &amp; Dolmøy seafood) samt Bjørns eget tangbrød fra Fjellværøya.<br>3 sorter Bacalao: Rød, hvit og blå! Med masse tilbehør og nystekte olivenbrød.<br>Bjørns krabbemousse fra Hitra med nybakte brød til, og til slutt:<br>Hemmelig dessert fra Bjørns besøk på Kongeskipet Norge!\n\nMeld fra om det er matallergier eller annet vi bør vite om.\n\nHver rett serveres med en historie, og det serveres musikk før, under og etter maten.\n\n18.00 Velkommen (Info med drikke og underholdning)\n\n19.00 3 retter serveres med underholdning\n\n21.00 Musikk og underholdning\n\n22.00 Dessert serveres\n\nBar åpen til kl 23.30 – dørene stenger kl 24.00\n\nDiverse øl, med og uten alkohol, prosecco, cava, champagne og gode viner som passer til maten og musikken. 5 sorter akevitt, konjakk og likører kan serveres, for Visit Bjørn har alle rettigheter.\n\nFor grupper kan du få eget opplegg på egne kvelder om du ønsker.\n\nSend en e-post til <a href="mailto:bjorn@visitbjorn.com">bjorn@visitbjorn.com</a>\n\nVISIT BJØRN ER AUTORISERT VERTSKAP FOR «EUROPEAN REGION OF GASTRONOMY»',
        place: 'Visit Bjørn i Carl Johan',
        address: 'Carl Johans gate 12, 7010 Trondheim, Norge',
        time: '18:00',
        date: '18.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/visit-bjorn-bacalao-party/'
    },
    {
        title: 'Sabrura City Syd',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F8RyhI_large.jpg?alt=media&token=e9582e0b-7355-446a-9a6c-4db0ed776ae1',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura City Syd har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: 'City Syd',
        address: 'Østre Rosten 28-30, 7075 Tiller, Norge',
        time: '10:15 - 20:00',
        date: '19.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-city-syd-3/'
    },
    {
        title: 'Krambua 15/3 – 21/3 2024',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F6gHIG_large.jpg?alt=media&token=d4bb2e27-69b3-4fb0-ae38-9e148366f0f7',
        description:
            'På Krambua, i Krambugata, er du hjertelig velkommen enten det er hverdag eller fest. Hos oss møter du hyggelige folk og kan spise god mat i stemningsfulle lokaler. Er du ute etter en god lunsj, middag eller bare noe godt å drikke i baren så vil du uansett finne deg godt til rette i de uformelle og koselige lokalene våre i Trondheim. Ønsker du å booke ditt eget rom kan vil tilby dette til deg og din gruppe. Bestill gjerne bord så er du sikker på å få plass!\n\nPå Krambua kan vi friste med mye godt på menyen og hjemmelaget Bacalao til redusert pris under hele festivalperioden 15/03 – 21/03 Tilbudspris kr. 299,-\n\nHusk å reservere bord i god tid.\n\n<a href="https://www.krambuatrondheim.no/reservations">Bestill bord — Krambua (krambuatrondheim.no)</a>\n\n<a href="mailto:post@krambua.no">post@krambua.no</a>\n\nTlf: 73535253',
        place: 'Krambua',
        address: 'Krambugata 12-14 Trondheim 7010',
        time: '11:00',
        date: '19.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/krambua-15-3-21-3-2024-3/'
    },
    {
        title: 'Sabrura Sirkus!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FQ17dd_large.jpg?alt=media&token=106b9884-51e5-4a55-b0b3-3ac23393c463',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura Sirkus har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: 'Sirkus Shopping',
        address: 'Falkenborgvegen 1, 7044 Trondheim, Norge',
        time: '11:00 - 21:00',
        date: '19.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-sirkus-3/'
    },
    {
        title: 'San Sebastian Tapas',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FPxgSb_large.jpg?alt=media&token=65ddb077-5fa0-49c6-b4f2-5ec291eea9aa',
        description:
            'San Sebastian hiver seg med på feiringen\n\nSjømat vil være i fokus på menyen denne uken, blant annet med blåskjell fra Åfjord og kveite fra Averøy.\n\nKom innom oss for deilige spanske smaker med norske råvarer\n\nVelg blant over 35 av våre tapas-retter',
        place: 'Midtbyen/ Trondheim torg',
        address: 'Kongens gate 9, 7013 Trondheim, Norge',
        time: '11:00 - 21:00',
        date: '19.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/san-sebastian-tapas-3/'
    },
    {
        title: 'Sabrura City Lade',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FxlOAY_large.jpg?alt=media&token=084fbfb0-34d2-408f-a669-33be0098e3ff',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura City Lade har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: 'City lade',
        address: 'Haakon VIIs gt. 9, 7041 Trondheim, Norge',
        time: '11:00 - 21:00',
        date: '19.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-city-lade-3/'
    },
    {
        title: 'SOT Sabrura Torvet!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FwTzRg_large.jpg?alt=media&token=5bf84749-2b36-4c64-8808-d6ccaa6ccba2',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på SOT Sabrura Torvet har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: '',
        address: '',
        time: '11:00 - 22:00',
        date: '19.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sot-sabrura-torvet-5/'
    },
    {
        title: 'Sabrura Solsiden!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2Frytvk_large.jpg?alt=media&token=cfc8b521-00c1-4ab1-b6c7-3ab8edc7de7c',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura Solsiden har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: '',
        address: '',
        time: '13:00 - 22:00',
        date: '19.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-solsiden-5/'
    },
    {
        title: 'Sabrura Bakklandet!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FNt0um_large.jpg?alt=media&token=38e496a4-90cc-41c8-aacd-3e4925862832',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura Bakklandet har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: '',
        address: '',
        time: '15:00 - 22:00',
        date: '19.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-bakklandet-5/'
    },
    {
        title: 'Bakgården Tapas!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F34Moe_large.jpg?alt=media&token=6302aeb0-2930-4240-85a1-121be58bf8e3',
        description:
            'På Bakgården Tapas bar og spiseri er vi med på feiringen!&nbsp;\n\nSjømat vil være i fokus på menyen denne uken. Vi tilbyr både stor og liten sjømatsmeny til gode priser, hvor fokuset ligger på Norske råvarer . &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
        place: 'Bakgården Bar og Spiseri',
        address: 'Kjøpmannsgata 40, 7011 Trondheim, Norge',
        time: '15:00 - 22:00',
        date: '19.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/bakgarden-tapas-5/'
    },
    {
        title: 'Grafen Trondheim',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2Fqahfy_large.jpg?alt=media&token=8ba84fee-5731-4371-b10a-5870ef7b8184',
        description:
            '15-21 mar arrangeres Norwegian Seafood Festival, og Grafen ønsker selvsagt og være med på feiringen. I perioden vil vi tilby en egen meny med fokos på råvarene som også har fokus i Bocuse d`or Trondheim 2024.\n\nMenyen vil ha fokus på havets delikatesser som skrei, kamskjell og klippfisk.\n\nVår a la carte vil også i perioden bære preg av byens arrangement.\n\nBord kan bookes online på www.grafentrondheim.no/booking',
        place: 'Grafen Trondheim',
        address: 'Kongens gate 8, 7011 Trondheim, Norge',
        time: '16:00 - 22:00',
        date: '19.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/grafen-trondheim-5/'
    },
    {
        title: 'Akt Bar og Smugspiseri',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FLGVxI_large.jpg?alt=media&token=f2380bb4-9397-43d0-8d23-d4424688ecdd',
        description:
            '15.-21. mars i år arrangeres Norway Seafood Festival i Trondheim. &nbsp;\n\nPå Akt Bar og Smugspiseri er vi med på feiringen, og sjømat vil være i fokus på menyen denne uken.\n\nBesøk oss for en deilig 3-retters middag, eller velg fra vår spennende a la carte meny.',
        place: 'Akt Bar og Smugspiseri',
        address: 'Kjøpmannsgata 44, 7010 Trondheim, Norge',
        time: '16:00',
        date: '19.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/akt-bar-og-smugspiseri-3/'
    },
    {
        title: 'The Crab og Norway Seafood Festival',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FioshX_large.jpg?alt=media&token=d97c2f0f-71fa-40b4-b784-4ee292f8b04f',
        description:
            '15.-21. mars arrangeres Norway Seafoof Festival i Trondheim og The Crab deltar så klart.\n\nVi har som vanlig fokus på de beste råvarene fra havet i våre menyer og gleder oss til å ta imot alle sjømat-elskere denne uka!\n\nLørdag arrangerer vi skalldyrkurs med Ola kl 12. (Se eget event)\n\nVelkommen til oss!\n\nFor booking <a href="www.thecrab.no">www.thecrab.no</a> eller send en epost til post@thecrab.no',
        place: 'The Crab, Kjøpmannsgata 7',
        address: 'Kjøpmannsgata 7, 7013 Trondheim, Norge',
        time: '16:00 - 22:00',
        date: '19.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/the-crab-og-norway-seafood-festival-3/'
    },
    {
        title: 'Brasserie Britannia',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FwwmNV_large.jpg?alt=media&token=85529179-16f6-4e22-abfe-f3db7e7ebe56',
        description:
            'I forbindelse med Norway Seafood Festival vil Brasserie Britannia servere en 3-retters meny basert på flotte lokale råvarer fra havet fra 15.03 tom. 21.03.',
        place: 'Britannia Hotel',
        address: 'Dronningens gate 5, 7011 Trondheim, Norge',
        time: '16:00 - 22:00',
        date: '19.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/brasserie-britannia-5/'
    },
    {
        title: 'To Rom og Kjøkken',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F20XxY_large.jpg?alt=media&token=7d2d7ea5-aff7-400b-a0f2-18c78f9679ad',
        description:
            '15.-21. mars i år arrangeres Norway Seafood Festival i Trondheim.\n\nPå To Rom og Kjøkken er vi med på feiringen, og sjømat vil være i fokus på menyen denne uken.\n\nVi serverer våre Smaksmenyer på 3-, 5- og 7-retters menyer, hvor lokal sjømat og det beste fra havet spiller hovedrollen.',
        place: 'To Rom og Kjøkken',
        address: 'Carl Johans gate 5 Trondheim   7010 Norway',
        time: '16:00 - 22:00',
        date: '19.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/to-rom-og-kjokken-5/'
    },
    {
        title: 'E.C. Dahls Pub og Kjøkken',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FpY2n5_large.jpg?alt=media&token=50d86d6c-73f4-476b-983e-46e2d1fea01e',
        description:
            '15-21. Mars arrangeres Norway Seafood Festival I Trondheim\n\nE.C. Dahls Pub og Kjøkken tilbyr i denne perioden en 3-retters meny med sjømat og lokale råvarer fra Midt-Norge',
        place: 'E.C.Dahls Pub og Kjøkken',
        address: 'Strandv 71 Trondheim 7067',
        time: '17:00',
        date: '19.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/e-c-dahls-pub-og-kjokken/'
    },
    {
        title: 'Spontan x sjømat festival',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F0JnQh_large.jpg?alt=media&token=94d2e9fd-29a6-4090-891c-b1fc28d10791',
        description:
            '15.-21. mars i år arrangeres Norway Seafood Festival i Trondheim.\n\nVi gleder oss masse til sjømat festivalen og tilbyr i denne perioden en meny på syv serveringer av lokale råvarer og sjømat fra Trøndelag\n\nphoto: Even B Solheim. ebs.photography&nbsp;',
        place: 'Spontan Vinbar',
        address: 'Fjordgata 1, 7010 Trondheim, Norway',
        time: '17:00',
        date: '19.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/spontan-x-sjomat-festival-3/'
    },
    {
        title: 'Fagn Bistro',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F352Xc_large.jpg?alt=media&token=18fb60d5-5951-4f01-ab8b-a13cd5d61271',
        description:
            '15-21.mars arrangeres Norway Seafood Festival I Trondheim\n\nFagn Bistro tilbyr denne perioden 3 og 5 retters meny med fokus på sjømat og lokale råvarer',
        place: 'Fagn Bistro',
        address: 'Ørjaveita 4, 7010 Trondheim, Norge',
        time: '17:00 - 22:00',
        date: '19.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/fagn-bistro/'
    },
    {
        title: 'Sabrura City Syd',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F8RyhI_large.jpg?alt=media&token=e9582e0b-7355-446a-9a6c-4db0ed776ae1',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura City Syd har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: 'City Syd',
        address: 'Østre Rosten 28-30, 7075 Tiller, Norge',
        time: '10:15 - 20:00',
        date: '20.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-city-syd-5/'
    },
    {
        title: 'San Sebastian Tapas',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FPxgSb_large.jpg?alt=media&token=65ddb077-5fa0-49c6-b4f2-5ec291eea9aa',
        description:
            'San Sebastian hiver seg med på feiringen\n\nSjømat vil være i fokus på menyen denne uken, blant annet med blåskjell fra Åfjord og kveite fra Averøy.\n\nKom innom oss for deilige spanske smaker med norske råvarer\n\nVelg blant over 35 av våre tapas-retter',
        place: 'Midtbyen/ Trondheim torg',
        address: 'Kongens gate 9, 7013 Trondheim, Norge',
        time: '11:00 - 21:00',
        date: '20.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/san-sebastian-tapas-4/'
    },
    {
        title: 'SOT Sabrura Torvet!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FwTzRg_large.jpg?alt=media&token=5bf84749-2b36-4c64-8808-d6ccaa6ccba2',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på SOT Sabrura Torvet har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: '',
        address: '',
        time: '11:00 - 22:00',
        date: '20.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sot-sabrura-torvet-7/'
    },
    {
        title: 'Sabrura City Lade',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FxlOAY_large.jpg?alt=media&token=084fbfb0-34d2-408f-a669-33be0098e3ff',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura City Lade har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: 'City lade',
        address: 'Haakon VIIs gt. 9, 7041 Trondheim, Norge',
        time: '11:00 - 21:00',
        date: '20.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-city-lade-5/'
    },
    {
        title: 'Sabrura Sirkus!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FQ17dd_large.jpg?alt=media&token=106b9884-51e5-4a55-b0b3-3ac23393c463',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura Sirkus har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: 'Sirkus Shopping',
        address: 'Falkenborgvegen 1, 7044 Trondheim, Norge',
        time: '11:00 - 21:00',
        date: '20.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-sirkus-5/'
    },
    {
        title: 'Krambua 15/3 – 21/3 2024',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F6gHIG_large.jpg?alt=media&token=d4bb2e27-69b3-4fb0-ae38-9e148366f0f7',
        description:
            'På Krambua, i Krambugata, er du hjertelig velkommen enten det er hverdag eller fest. Hos oss møter du hyggelige folk og kan spise god mat i stemningsfulle lokaler. Er du ute etter en god lunsj, middag eller bare noe godt å drikke i baren så vil du uansett finne deg godt til rette i de uformelle og koselige lokalene våre i Trondheim. Ønsker du å booke ditt eget rom kan vil tilby dette til deg og din gruppe. Bestill gjerne bord så er du sikker på å få plass!\n\nPå Krambua kan vi friste med mye godt på menyen og hjemmelaget Bacalao til redusert pris under hele festivalperioden 15/03 – 21/03 Tilbudspris kr. 299,-\n\nHusk å reservere bord i god tid.\n\n<a href="https://www.krambuatrondheim.no/reservations">Bestill bord — Krambua (krambuatrondheim.no)</a>\n\n<a href="mailto:post@krambua.no">post@krambua.no</a>\n\nTlf: 73535253',
        place: 'Krambua',
        address: 'Krambugata 12-14 Trondheim 7010',
        time: '11:00',
        date: '20.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/krambua-15-3-21-3-2024-5/'
    },
    {
        title: 'Sabrura Solsiden!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2Frytvk_large.jpg?alt=media&token=cfc8b521-00c1-4ab1-b6c7-3ab8edc7de7c',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura Solsiden har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: '',
        address: '',
        time: '13:00 - 22:00',
        date: '20.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-solsiden-7/'
    },
    {
        title: 'Sabrura Bakklandet!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FNt0um_large.jpg?alt=media&token=38e496a4-90cc-41c8-aacd-3e4925862832',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura Bakklandet har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: '',
        address: '',
        time: '15:00 - 22:00',
        date: '20.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-bakklandet-7/'
    },
    {
        title: 'Bakgården Tapas!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F34Moe_large.jpg?alt=media&token=6302aeb0-2930-4240-85a1-121be58bf8e3',
        description:
            'På Bakgården Tapas bar og spiseri er vi med på feiringen!&nbsp;\n\nSjømat vil være i fokus på menyen denne uken. Vi tilbyr både stor og liten sjømatsmeny til gode priser, hvor fokuset ligger på Norske råvarer . &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
        place: 'Bakgården Bar og Spiseri',
        address: 'Kjøpmannsgata 40, 7011 Trondheim, Norge',
        time: '15:00 - 22:00',
        date: '20.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/bakgarden-tapas-7/'
    },
    {
        title: 'Akt Bar og Smugspiseri',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FLGVxI_large.jpg?alt=media&token=f2380bb4-9397-43d0-8d23-d4424688ecdd',
        description:
            '15.-21. mars i år arrangeres Norway Seafood Festival i Trondheim. &nbsp;\n\nPå Akt Bar og Smugspiseri er vi med på feiringen, og sjømat vil være i fokus på menyen denne uken.\n\nBesøk oss for en deilig 3-retters middag, eller velg fra vår spennende a la carte meny.',
        place: 'Akt Bar og Smugspiseri',
        address: 'Kjøpmannsgata 44, 7010 Trondheim, Norge',
        time: '16:00',
        date: '20.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/akt-bar-og-smugspiseri-5/'
    },
    {
        title: 'The Crab og Norway Seafood Festival',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FioshX_large.jpg?alt=media&token=d97c2f0f-71fa-40b4-b784-4ee292f8b04f',
        description:
            '15.-21. mars arrangeres Norway Seafoof Festival i Trondheim og The Crab deltar så klart.\n\nVi har som vanlig fokus på de beste råvarene fra havet i våre menyer og gleder oss til å ta imot alle sjømat-elskere denne uka!\n\nLørdag arrangerer vi skalldyrkurs med Ola kl 12. (Se eget event)\n\nVelkommen til oss!\n\nFor booking <a href="www.thecrab.no">www.thecrab.no</a> eller send en epost til post@thecrab.no',
        place: 'The Crab, Kjøpmannsgata 7',
        address: 'Kjøpmannsgata 7, 7013 Trondheim, Norge',
        time: '16:00 - 22:00',
        date: '20.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/the-crab-og-norway-seafood-festival-5/'
    },
    {
        title: 'Grafen Trondheim',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2Fqahfy_large.jpg?alt=media&token=8ba84fee-5731-4371-b10a-5870ef7b8184',
        description:
            '15-21 mar arrangeres Norwegian Seafood Festival, og Grafen ønsker selvsagt og være med på feiringen. I perioden vil vi tilby en egen meny med fokos på råvarene som også har fokus i Bocuse d`or Trondheim 2024.\n\nMenyen vil ha fokus på havets delikatesser som skrei, kamskjell og klippfisk.\n\nVår a la carte vil også i perioden bære preg av byens arrangement.\n\nBord kan bookes online på www.grafentrondheim.no/booking',
        place: 'Grafen Trondheim',
        address: 'Kongens gate 8, 7011 Trondheim, Norge',
        time: '16:00 - 22:00',
        date: '20.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/grafen-trondheim-7/'
    },
    {
        title: 'Brasserie Britannia',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FwwmNV_large.jpg?alt=media&token=85529179-16f6-4e22-abfe-f3db7e7ebe56',
        description:
            'I forbindelse med Norway Seafood Festival vil Brasserie Britannia servere en 3-retters meny basert på flotte lokale råvarer fra havet fra 15.03 tom. 21.03.',
        place: 'Britannia Hotel',
        address: 'Dronningens gate 5, 7011 Trondheim, Norge',
        time: '16:00 - 22:00',
        date: '20.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/brasserie-britannia-7/'
    },
    {
        title: 'To Rom og Kjøkken',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F20XxY_large.jpg?alt=media&token=7d2d7ea5-aff7-400b-a0f2-18c78f9679ad',
        description:
            '15.-21. mars i år arrangeres Norway Seafood Festival i Trondheim.\n\nPå To Rom og Kjøkken er vi med på feiringen, og sjømat vil være i fokus på menyen denne uken.\n\nVi serverer våre Smaksmenyer på 3-, 5- og 7-retters menyer, hvor lokal sjømat og det beste fra havet spiller hovedrollen.',
        place: 'To Rom og Kjøkken',
        address: 'Carl Johans gate 5 Trondheim   7010 Norway',
        time: '16:00 - 22:00',
        date: '20.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/to-rom-og-kjokken-7/'
    },
    {
        title: 'Fagn Bistro',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F352Xc_large.jpg?alt=media&token=18fb60d5-5951-4f01-ab8b-a13cd5d61271',
        description:
            '15-21.mars arrangeres Norway Seafood Festival I Trondheim\n\nFagn Bistro tilbyr denne perioden 3 og 5 retters meny med fokus på sjømat og lokale råvarer',
        place: 'Fagn Bistro',
        address: 'Ørjaveita 4, 7010 Trondheim, Norge',
        time: '17:00 - 22:00',
        date: '20.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/fagn-bistro-3/'
    },
    {
        title: 'Spontan x sjømat festival',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F0JnQh_large.jpg?alt=media&token=94d2e9fd-29a6-4090-891c-b1fc28d10791',
        description:
            '15.-21. mars i år arrangeres Norway Seafood Festival i Trondheim.\n\nVi gleder oss masse til sjømat festivalen og tilbyr i denne perioden en meny på syv serveringer av lokale råvarer og sjømat fra Trøndelag\n\nphoto: Even B Solheim. ebs.photography&nbsp;',
        place: 'Spontan Vinbar',
        address: 'Fjordgata 1, 7010 Trondheim, Norway',
        time: '17:00',
        date: '20.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/spontan-x-sjomat-festival-5/'
    },
    {
        title: 'E.C. Dahls Pub og Kjøkken',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FpY2n5_large.jpg?alt=media&token=50d86d6c-73f4-476b-983e-46e2d1fea01e',
        description:
            '15-21. Mars arrangeres Norway Seafood Festival I Trondheim\n\nE.C. Dahls Pub og Kjøkken tilbyr i denne perioden en 3-retters meny med sjømat og lokale råvarer fra Midt-Norge',
        place: 'E.C.Dahls Pub og Kjøkken',
        address: 'Strandv 71 Trondheim 7067',
        time: '17:00',
        date: '20.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/e-c-dahls-pub-og-kjokken-3/'
    },
    {
        title: 'Sabrura City Syd',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F8RyhI_large.jpg?alt=media&token=e9582e0b-7355-446a-9a6c-4db0ed776ae1',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura City Syd har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: 'City Syd',
        address: 'Østre Rosten 28-30, 7075 Tiller, Norge',
        time: '10:15 - 20:00',
        date: '21.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-city-syd-7/'
    },
    {
        title: 'Krambua 15/3 – 21/3 2024',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F6gHIG_large.jpg?alt=media&token=d4bb2e27-69b3-4fb0-ae38-9e148366f0f7',
        description:
            'På Krambua, i Krambugata, er du hjertelig velkommen enten det er hverdag eller fest. Hos oss møter du hyggelige folk og kan spise god mat i stemningsfulle lokaler. Er du ute etter en god lunsj, middag eller bare noe godt å drikke i baren så vil du uansett finne deg godt til rette i de uformelle og koselige lokalene våre i Trondheim. Ønsker du å booke ditt eget rom kan vil tilby dette til deg og din gruppe. Bestill gjerne bord så er du sikker på å få plass!\n\nPå Krambua kan vi friste med mye godt på menyen og hjemmelaget Bacalao til redusert pris under hele festivalperioden 15/03 – 21/03 Tilbudspris kr. 299,-\n\nHusk å reservere bord i god tid.\n\n<a href="https://www.krambuatrondheim.no/reservations">Bestill bord — Krambua (krambuatrondheim.no)</a>\n\n<a href="mailto:post@krambua.no">post@krambua.no</a>\n\nTlf: 73535253',
        place: 'Krambua',
        address: 'Krambugata 12-14 Trondheim 7010',
        time: '11:00',
        date: '21.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/krambua-15-3-21-3-2024-7/'
    },
    {
        title: 'Sabrura Sirkus!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FQ17dd_large.jpg?alt=media&token=106b9884-51e5-4a55-b0b3-3ac23393c463',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura Sirkus har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: 'Sirkus Shopping',
        address: 'Falkenborgvegen 1, 7044 Trondheim, Norge',
        time: '11:00 - 21:00',
        date: '21.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-sirkus-7/'
    },
    {
        title: 'Sabrura City Lade',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FxlOAY_large.jpg?alt=media&token=084fbfb0-34d2-408f-a669-33be0098e3ff',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura City Lade har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: 'City lade',
        address: 'Haakon VIIs gt. 9, 7041 Trondheim, Norge',
        time: '11:00 - 21:00',
        date: '21.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-city-lade-7/'
    },
    {
        title: 'San Sebastian Tapas',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FPxgSb_large.jpg?alt=media&token=65ddb077-5fa0-49c6-b4f2-5ec291eea9aa',
        description:
            'San Sebastian hiver seg med på feiringen\n\nSjømat vil være i fokus på menyen denne uken, blant annet med blåskjell fra Åfjord og kveite fra Averøy.\n\nKom innom oss for deilige spanske smaker med norske råvarer\n\nVelg blant over 35 av våre tapas-retter',
        place: 'Midtbyen/ Trondheim torg',
        address: 'Kongens gate 9, 7013 Trondheim, Norge',
        time: '11:00',
        date: '21.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/san-sebastian-tapas-5/'
    },
    {
        title: 'SOT Sabrura Torvet!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FwTzRg_large.jpg?alt=media&token=5bf84749-2b36-4c64-8808-d6ccaa6ccba2',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på SOT Sabrura Torvet har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: '',
        address: '',
        time: '11:00 - 22:00',
        date: '21.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sot-sabrura-torvet-9/'
    },
    {
        title: 'Sabrura Solsiden!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2Frytvk_large.jpg?alt=media&token=cfc8b521-00c1-4ab1-b6c7-3ab8edc7de7c',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura Solsiden har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: '',
        address: '',
        time: '13:00 - 22:00',
        date: '21.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-solsiden-9/'
    },
    {
        title: 'Sabrura Bakklandet!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FNt0um_large.jpg?alt=media&token=38e496a4-90cc-41c8-aacd-3e4925862832',
        description:
            'Norway Seafood Festival kommer til Trondheim fra 15. – 21. mars og vi på Sabrura Bakklandet har gleden av å være med på festlighetene <img draggable="false" role="img" class="emoji" alt="🥳" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f973.svg">\n\nI denne anledning kjører vi en helt egen Norway Seafood Festival kombo! Gode ting kommer til de som venter…',
        place: '',
        address: '',
        time: '15:00 - 22:00',
        date: '21.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/sabrura-bakklandet-9/'
    },
    {
        title: 'Bakgården Tapas!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F34Moe_large.jpg?alt=media&token=6302aeb0-2930-4240-85a1-121be58bf8e3',
        description:
            'På Bakgården Tapas bar og spiseri er vi med på feiringen!&nbsp;\n\nSjømat vil være i fokus på menyen denne uken. Vi tilbyr både stor og liten sjømatsmeny til gode priser, hvor fokuset ligger på Norske råvarer . &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
        place: 'Bakgården Bar og Spiseri',
        address: 'Kjøpmannsgata 40, 7011 Trondheim, Norge',
        time: '15:00 - 22:00',
        date: '21.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/bakgarden-tapas-9/'
    },
    {
        title: 'Brasserie Britannia',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FwwmNV_large.jpg?alt=media&token=85529179-16f6-4e22-abfe-f3db7e7ebe56',
        description:
            'I forbindelse med Norway Seafood Festival vil Brasserie Britannia servere en 3-retters meny basert på flotte lokale råvarer fra havet fra 15.03 tom. 21.03.',
        place: 'Britannia Hotel',
        address: 'Dronningens gate 5, 7011 Trondheim, Norge',
        time: '16:00 - 22:00',
        date: '21.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/brasserie-britannia-9/'
    },
    {
        title: 'The Crab og Norway Seafood Festival',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FioshX_large.jpg?alt=media&token=d97c2f0f-71fa-40b4-b784-4ee292f8b04f',
        description:
            '15.-21. mars arrangeres Norway Seafoof Festival i Trondheim og The Crab deltar så klart.\n\nVi har som vanlig fokus på de beste råvarene fra havet i våre menyer og gleder oss til å ta imot alle sjømat-elskere denne uka!\n\nLørdag arrangerer vi skalldyrkurs med Ola kl 12. (Se eget event)\n\nVelkommen til oss!\n\nFor booking <a href="www.thecrab.no">www.thecrab.no</a> eller send en epost til post@thecrab.no',
        place: 'The Crab, Kjøpmannsgata 7',
        address: 'Kjøpmannsgata 7, 7013 Trondheim, Norge',
        time: '16:00 - 22:00',
        date: '21.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/the-crab-og-norway-seafood-festival-7/'
    },
    {
        title: 'Akt Bar og Smugspiseri',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FLGVxI_large.jpg?alt=media&token=f2380bb4-9397-43d0-8d23-d4424688ecdd',
        description:
            '15.-21. mars i år arrangeres Norway Seafood Festival i Trondheim. &nbsp;\n\nPå Akt Bar og Smugspiseri er vi med på feiringen, og sjømat vil være i fokus på menyen denne uken.\n\nBesøk oss for en deilig 3-retters middag, eller velg fra vår spennende a la carte meny.',
        place: 'Akt Bar og Smugspiseri',
        address: 'Kjøpmannsgata 44, 7010 Trondheim, Norge',
        time: '16:00',
        date: '21.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/akt-bar-og-smugspiseri-7/'
    },
    {
        title: 'To Rom og Kjøkken',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F20XxY_large.jpg?alt=media&token=7d2d7ea5-aff7-400b-a0f2-18c78f9679ad',
        description:
            '15.-21. mars i år arrangeres Norway Seafood Festival i Trondheim.\n\nPå To Rom og Kjøkken er vi med på feiringen, og sjømat vil være i fokus på menyen denne uken.\n\nVi serverer våre Smaksmenyer på 3-, 5- og 7-retters menyer, hvor lokal sjømat og det beste fra havet spiller hovedrollen.',
        place: 'To Rom og Kjøkken',
        address: 'Carl Johans gate 5 Trondheim   7010 Norway',
        time: '16:00 - 22:00',
        date: '21.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/to-rom-og-kjokken-9/'
    },
    {
        title: 'Grafen Trondheim',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2Fqahfy_large.jpg?alt=media&token=8ba84fee-5731-4371-b10a-5870ef7b8184',
        description:
            '15-21 mar arrangeres Norwegian Seafood Festival, og Grafen ønsker selvsagt og være med på feiringen. I perioden vil vi tilby en egen meny med fokos på råvarene som også har fokus i Bocuse d`or Trondheim 2024.\n\nMenyen vil ha fokus på havets delikatesser som skrei, kamskjell og klippfisk.\n\nVår a la carte vil også i perioden bære preg av byens arrangement.\n\nBord kan bookes online på www.grafentrondheim.no/booking',
        place: 'Grafen Trondheim',
        address: 'Kongens gate 8, 7011 Trondheim, Norge',
        time: '16:00 - 22:00',
        date: '21.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/grafen-trondheim-9/'
    },
    {
        title: 'Spontan x sjømat festival',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F0JnQh_large.jpg?alt=media&token=94d2e9fd-29a6-4090-891c-b1fc28d10791',
        description:
            '15.-21. mars i år arrangeres Norway Seafood Festival i Trondheim.\n\nVi gleder oss masse til sjømat festivalen og tilbyr i denne perioden en meny på syv serveringer av lokale råvarer og sjømat fra Trøndelag\n\nphoto: Even B Solheim. ebs.photography&nbsp;',
        place: 'Spontan Vinbar',
        address: 'Fjordgata 1, 7010 Trondheim, Norway',
        time: '17:00',
        date: '21.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/spontan-x-sjomat-festival-7/'
    },
    {
        title: 'Fagn Bistro',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2F352Xc_large.jpg?alt=media&token=18fb60d5-5951-4f01-ab8b-a13cd5d61271',
        description:
            '15-21.mars arrangeres Norway Seafood Festival I Trondheim\n\nFagn Bistro tilbyr denne perioden 3 og 5 retters meny med fokus på sjømat og lokale råvarer',
        place: 'Fagn Bistro',
        address: 'Ørjaveita 4, 7010 Trondheim, Norge',
        time: '17:00 - 22:00',
        date: '21.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/fagn-bistro-5/'
    },
    {
        title: 'E.C. Dahls Pub og Kjøkken',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FpY2n5_large.jpg?alt=media&token=50d86d6c-73f4-476b-983e-46e2d1fea01e',
        description:
            '15-21. Mars arrangeres Norway Seafood Festival I Trondheim\n\nE.C. Dahls Pub og Kjøkken tilbyr i denne perioden en 3-retters meny med sjømat og lokale råvarer fra Midt-Norge',
        place: 'E.C.Dahls Pub og Kjøkken',
        address: 'Strandv 71 Trondheim 7067',
        time: '17:00',
        date: '21.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/e-c-dahls-pub-og-kjokken-5/'
    },
    {
        title: 'Visit Bjørns Bacalao Party!',
        imageUrl:
            'https://firebasestorage.googleapis.com/v0/b/trdevents-224613.appspot.com/o/entities%2Fimages%2FuW7Ob_large.jpg?alt=media&token=9426dfce-8b62-42b6-abb0-975a6b545944',
        description:
            'Billetten inkluderer all mat og underholdning, du velger og kjøper drikke underveis.\n\nDet serveres røkt laks og ørret fra Hitra og Frøya (Garnviks Røkeri &amp; Dolmøy seafood) samt Bjørns eget tangbrød fra Fjellværøya.<br>3 sorter Bacalao: Rød, hvit og blå! Med masse tilbehør og nystekte olivenbrød.<br>Bjørns krabbemousse fra Hitra med nybakte brød til, og til slutt:<br>Hemmelig dessert fra Bjørns besøk på Kongeskipet Norge!\n\nMeld fra om det er matallergier eller annet vi bør vite om.\n\nHver rett serveres med en historie, og det serveres musikk før, under og etter maten.\n\n18.00 Velkommen (Info med drikke og underholdning)\n\n19.00 3 retter serveres med underholdning\n\n21.00 Musikk og underholdning\n\n22.00 Dessert serveres\n\nBar åpen til kl 23.30 – dørene stenger kl 24.00\n\nDiverse øl, med og uten alkohol, prosecco, cava, champagne og gode viner som passer til maten og musikken. 5 sorter akevitt, konjakk og likører kan serveres, for Visit Bjørn har alle rettigheter.\n\nFor grupper kan du få eget opplegg på egne kvelder om du ønsker.\n\nSend en e-post til <a href="mailto:bjorn@visitbjorn.com">bjorn@visitbjorn.com</a>\n\nVISIT BJØRN ER AUTORISERT VERTSKAP FOR «EUROPEAN REGION OF GASTRONOMY»',
        place: 'Visit Bjørn i Carl Johan',
        address: 'Carl Johans gate 12, 7010 Trondheim, Norge',
        time: '18:00 - 23:00',
        date: '21.03.2024',
        sourceUrl: 'https://norwayseafoodfestival.no/event/visit-bjorns-bacalao-party/'
    }
];

export const SeafoodMarkersMap = {
    'Bakgården Bar og Spiseri': '0.3896951392036343',
    'Akt Bar og Smugspiseri': '0.8961966506691479',
    'Britannia Hotel': '0.6131171005497658', // shared for 2 locations
    'To Rom og Kjøkken': '0.8909635683712125',
    'Grafen Trondheim': '0.044006508836169855',
    'The Crab, Kjøpmannsgata 7': '0.8917534085043908',
    'Spontan Vinbar': '0.27802190892977285',
    'Fagn Bistro': '0.5081782664870327',
    'E.C.Dahls Pub og Kjøkken': '0.7996740531786444',
    'Visit Bjørn i Carl Johan': '0.9313495849972304',
    'Clarion Hotel Trondheim': '0.4143074308794392',
    Byhaven: '0.35422358046493585', // goes to Sabrura Byhavn
    'City Syd': '', // not on map
    'Midtbyen/ Trondheim torg': '', // not on map
    'Sirkus Shopping': '', // not on map
    Krambua: '0.8029409597988288',
    'City lade': '', // not on map
    'SOT Sabrura Torget': '', // not on map
    'Sabrura Solsiden': '', // not on map
    'Sabrura Bakklandet': '0.7728115053456213',
    'Le Bistro': '0.505161226996609'
};
